import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { externalPost } from '../utils/api';

const appNames = {
  fit: 'Fit',
  dine: 'Dine',
};
const defaultAppName = 'Spaces';

export const sendSms = async (
  origin: string,
  phoneNumber: string,
  recaptchaToken: unknown,
  instance: string,
  preferredApp: string,
  placeName: string,
  joinUrl: string,
  flowApi?: PlatformControllerFlowAPI, // Add flowApi parameter for error handling
) => {
  // If flowApi is not provided, use the original implementation
  
  if (!flowApi) {
    const headers = {
      Authorization: instance,
      'Content-Type': 'application/json',
    };
    const isVeloCaptcha = true;
    const parameters: any = {
      placeName,
      joinUrl,
    };
    if (preferredApp !== 'branded') {
      parameters.appName = appNames[preferredApp] || defaultAppName;
    }

    const data = {
      template: preferredApp === 'branded' ? 'labs-join' : 'labs-stay-updated',
      recaptchaToken,
      origin: 'labs',
      isVeloCaptcha,
      parameters,
    };

    return externalPost(
      `${origin}/_api/clubs-invites/sms/${phoneNumber.removeInvalidChars()}`,
      headers,
      data,
    );
  }

  // With error handling
  const { errorHandler, translations } = flowApi;
  const { t } = translations;
  const { withErrorHandler, getResolvedError } = errorHandler;
  
  try {
    return await withErrorHandler(
      async () => {
        const headers = {
          Authorization: instance,
          'Content-Type': 'application/json',
        };
        const isVeloCaptcha = true;
        const parameters: any = {
          placeName,
          joinUrl,
        };
        if (preferredApp !== 'branded') {
          parameters.appName = appNames[preferredApp] || defaultAppName;
        }

        const data = {
          template: preferredApp === 'branded' ? 'labs-join' : 'labs-stay-updated',
          recaptchaToken,
          origin: 'labs',
          isVeloCaptcha,
          parameters,
        };

        return externalPost(
          `${origin}/_api/clubs-invites/sms/${phoneNumber.removeInvalidChars()}`,
          headers,
          data,
        );
      },
      {
        errorCodesMap: {
          applicationError: {
            INVALID_INSTANCE: () => ({
              message: "Invalid app instance provided.",
            }),
            UNAUTHORIZED: () => ({
              message: "You are not authorized to send SMS.",
            }),
            INVALID_PHONE: () => ({
              message: "Invalid phone number provided.",
            }),
          },
          serverError: () => ({
            message: t('download_my_app.widget.serverError'),
          }),
        },
      },
    );
  } catch (error) {
    const resolvedError = getResolvedError(error);
    console.error('Error sending SMS:', resolvedError);
    
    // Fallback for any unexpected errors
    throw resolvedError; // For SMS, we might want to throw the error instead of returning a fallback
  }
};
